// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  ProximityPlacementGroup,
  ProximityPlacementGroupsListBySubscriptionOptionalParams,
  ProximityPlacementGroupsListByResourceGroupOptionalParams,
  ProximityPlacementGroupsGetOptionalParams,
  ProximityPlacementGroupsGetResponse,
  ProximityPlacementGroupsCreateOrUpdateOptionalParams,
  ProximityPlacementGroupsCreateOrUpdateResponse,
  ProximityPlacementGroupUpdate,
  ProximityPlacementGroupsUpdateOptionalParams,
  ProximityPlacementGroupsUpdateResponse,
  ProximityPlacementGroupsDeleteOptionalParams,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a ProximityPlacementGroups. */
export interface ProximityPlacementGroups {
  /**
   * Lists all proximity placement groups in a subscription.
   * @param options The options parameters.
   */
  listBySubscription(
    options?: ProximityPlacementGroupsListBySubscriptionOptionalParams,
  ): PagedAsyncIterableIterator<ProximityPlacementGroup>;
  /**
   * Lists all proximity placement groups in a resource group.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param options The options parameters.
   */
  listByResourceGroup(
    resourceGroupName: string,
    options?: ProximityPlacementGroupsListByResourceGroupOptionalParams,
  ): PagedAsyncIterableIterator<ProximityPlacementGroup>;
  /**
   * Retrieves information about a proximity placement group .
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param proximityPlacementGroupName The name of the proximity placement group.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    proximityPlacementGroupName: string,
    options?: ProximityPlacementGroupsGetOptionalParams,
  ): Promise<ProximityPlacementGroupsGetResponse>;
  /**
   * Create or update a proximity placement group.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param proximityPlacementGroupName The name of the proximity placement group.
   * @param parameters Parameters supplied to the Create Proximity Placement Group operation.
   * @param options The options parameters.
   */
  createOrUpdate(
    resourceGroupName: string,
    proximityPlacementGroupName: string,
    parameters: ProximityPlacementGroup,
    options?: ProximityPlacementGroupsCreateOrUpdateOptionalParams,
  ): Promise<ProximityPlacementGroupsCreateOrUpdateResponse>;
  /**
   * Update a proximity placement group.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param proximityPlacementGroupName The name of the proximity placement group.
   * @param parameters Parameters supplied to the Update Proximity Placement Group operation.
   * @param options The options parameters.
   */
  update(
    resourceGroupName: string,
    proximityPlacementGroupName: string,
    parameters: ProximityPlacementGroupUpdate,
    options?: ProximityPlacementGroupsUpdateOptionalParams,
  ): Promise<ProximityPlacementGroupsUpdateResponse>;
  /**
   * Delete a proximity placement group.
   * @param resourceGroupName The name of the resource group. The name is case insensitive.
   * @param proximityPlacementGroupName The name of the proximity placement group.
   * @param options The options parameters.
   */
  delete(
    resourceGroupName: string,
    proximityPlacementGroupName: string,
    options?: ProximityPlacementGroupsDeleteOptionalParams,
  ): Promise<void>;
}
